export const chatFeatureFlags = {
  /** Show the chat history sidebar (History button in header) */
  chatHistory: false,
  /** Show feedback (thumbs up/down) and copy buttons on assistant messages */
  messageFeedbackAndCopy: false,
  /** Show expand/collapse and hide buttons in the chat header */
  chatPanelControls: false,
  /** Show the chat toggle button in the app sidebar */
  sidebarChatToggle: false,
  /** Show the delete conversation option in the chat header menu */
  deleteConversation: false,
  /** Show the chat_message from langgraph/process in chat when thread-summarisation panel is active */
  summarisationChatMessage: true,
} as const;
